module.exports = __webpack_public_path__ + "img/TelefonicaWeb-Regular.bee5c544.svg";